import { useEffect, useState } from 'react';
import { ArrowRight, CheckCircle2, Workflow } from 'lucide-react';
import { useSaveData } from '../useSaveData';

export function CinematicHero() {
  const saveData = useSaveData();
  const [portrait, setPortrait] = useState(() => window.matchMedia('(max-width: 640px)').matches);
  const [reducedMotion, setReducedMotion] = useState(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  useEffect(() => {
    const portraitQuery = window.matchMedia('(max-width: 640px)');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const updatePortrait = () => setPortrait(portraitQuery.matches);
    const updateMotion = () => setReducedMotion(motionQuery.matches);
    portraitQuery.addEventListener('change', updatePortrait);
    motionQuery.addEventListener('change', updateMotion);
    return () => {
      portraitQuery.removeEventListener('change', updatePortrait);
      motionQuery.removeEventListener('change', updateMotion);
    };
  }, []);

  const demoBase = `/demos/portfolio-operations/${portrait ? 'portrait' : 'desktop'}`;

  return (
    <figure className="hero-system" aria-label="Manual work connected to a custom operations system">
      <picture className="hero-system__workplace" aria-hidden="true">
        <source media="(max-width: 640px)" srcSet="/cinematic/revision-04/portrait/poster.webp" />
        <img src="/cinematic/revision-04/desktop/poster.webp" alt="" fetchPriority="high" decoding="async" />
      </picture>

      <div className="hero-system__flow" aria-hidden="true">
        <span>Manual input</span><ArrowRight /><span>Connected system</span>
      </div>

      <div className="hero-system__product">
        <div className="hero-system__product-bar">
          <span><Workflow aria-hidden="true" />Operations platform</span>
          <small><CheckCircle2 aria-hidden="true" />Connected</small>
        </div>
        <picture className="hero-system__product-poster">
          <source media="(max-width: 640px)" srcSet="/demos/portfolio-operations/portrait-poster.webp" />
          <img
            src="/demos/portfolio-operations/desktop-poster.webp"
            alt="Fictional portfolio operations app connecting company data, reporting, and a permission-aware assistant."
            fetchPriority="high"
            decoding="async"
          />
        </picture>
        {!saveData && !reducedMotion && (
          <video key={demoBase} muted loop autoPlay playsInline preload="metadata" poster={`${demoBase}-poster.webp`} aria-hidden="true">
            <source src={`${demoBase}.webm`} type="video/webm" />
            <source src={`${demoBase}.mp4`} type="video/mp4" />
          </video>
        )}
      </div>

      <figcaption>Real workflow proof, built with fictional representative data.</figcaption>
    </figure>
  );
}
